import { render } from "./CorosEstadoEntrenamiento.vue?vue&type=template&id=05e19e3e&scoped=true"
import script from "./CorosEstadoEntrenamiento.vue?vue&type=script&lang=js"
export * from "./CorosEstadoEntrenamiento.vue?vue&type=script&lang=js"

import "./CorosEstadoEntrenamiento.vue?vue&type=style&index=0&id=05e19e3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e19e3e"]])

export default __exports__